import { render, staticRenderFns } from "./TraxTrainingCompetencyDomainsCrudSearch.vue?vue&type=template&id=134b2fd0"
import script from "./TraxTrainingCompetencyDomainsCrudSearch.vue?vue&type=script&lang=js"
export * from "./TraxTrainingCompetencyDomainsCrudSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports